<template>
    <m-form ref="form">
        <template #content-template>
            <v-layout wrap row justify-end>
                <v-flex xs12>
                    <e-typography-body-small class="mb-0">
                        Abonieren von Benachrichtigen zur digitalen Gefährdungsbeurteilung Ihres Unternehmens.
                    </e-typography-body-small>
                </v-flex>
                <v-flex xs12>
                    <e-switch-email v-model="form.emailActive"
                                    :loading="$wait.waiting(keys.profile.subscribe + 'email')"
                                    name="emailActive"
                                    ref="emailActive"
                                    @click.stop.prevent="email"/>
                </v-flex>
                <v-flex xs12 v-if="seen">
                    <e-switch-phone v-model="form.mobileActive"
                                    :loading="$wait.waiting(keys.profile.subscribe + 'phone')"
                                    name="mobileActive"
                                    ref="mobileActive"
                                    @click.stop.prevent="phone"/>
                </v-flex>
                <v-flex>
                    <e-typography-body-small class="mb-0">
                        Sie können Benachrichtigungen jederzeit wieder deaktivieren.
                    </e-typography-body-small>
                </v-flex>
            </v-layout>
        </template>
    </m-form>
</template>

<script>
    import MForm from "@modules/forms/m-form";
    import isEmpty from 'lodash/isEmpty'
    import vuexKeys from '@mixins/includes/_vuexKeys'
    import notifications from "@mixins/includes/_notifications";
    import dialogs from '@mixins/includes/_dialogs';
    import errorHandler from "@mixins/responses/_errorHandler";

    import {createNamespacedHelpers} from 'vuex';
    const {mapGetters, mapActions} = createNamespacedHelpers('profile');

    export default {
        name: 'm-form-profile-messages',
        components: {MForm},
        mixins: [vuexKeys, notifications, dialogs, errorHandler],
        $_veeValidate: {
            validator: 'new'
        },
        async created(){
            if(!isEmpty(this.$user.relationships.profile)){
                await this.requestProfile({id: this.$user.relationships.profile.data.id});
                this.form.emailActive = this.profile.emailActive;
                this.form.mobileActive = this.profile.mobileActive;
            }
        },
        beforeDestroy() {
            this.reset();
        },
        data: () => ({
            seen: false,

            form: {
                emailActive: null,
                mobileActive: null
            }
        }),
        computed: {
            ...mapGetters({
                getProfile: 'read'
            }),

            profile() {
                return this.getProfile(this.$user.relationships.profile.data.id);
            }
        },
        methods: {
            ...mapActions({
                requestProfile: 'read',
                subscribeToChanel: 'subscribe'
            }),

            async email() {
                if(!this.$user.attributes.email){
                    this.openDialog({type:'contactWithAdministrator', options:{contentType:'email'}});
                    return;
                }

                if (!this.form.emailActive) {
                    await this.request({}, 'email');

                    this.openDialog('emailConfirmation')
                        .then(() => {
                            this.form.emailActive = true;
                        });
                } else {
                    this.openDialog('switchDeactivation')
                        .then(async () => {
                            await this.request({emailActive: false}, 'email');
                            this.form.emailActive = false;
                        });
                }
            },

            async phone() {
                if(!this.$user.attributes.mobile){
                    this.openDialog({type:'contactWithAdministrator', options:{contentType:'phone'}});
                    return;
                }

                if (!this.form.mobileActive) {
                    await this.request({mobileActive: true}, 'phone');

                    this.openDialog('phoneConfirmation')
                        .then(() => {
                            this.form.mobileActive = true;
                        });
                } else {
                    this.openDialog('switchDeactivation')
                        .then(async () => {
                            await this.request({mobileActive: false}, 'phone');
                            this.form.mobileActive = false;
                        });
                }
            },

            async request(data, type) {
                try {
                    await this.subscribeToChanel({
                        _id: this.profile._id,
                        data: data,
                        type: type
                    });
                } catch (e) {
                    this.error.handle(e);
                }
            },

            reset() {
                this.$refs.form.reset();
                this.$validator.reset();
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
